import { getElapsedMs, isRunningTimer, TimerState } from "../store"
import { useTicker } from "../../hooks/use-ticker"

export const useElapsedMs = (timer: TimerState): { elapsed: number; formattedElapsed: FormattedElapsed } => {
  useTicker(isRunningTimer(timer))
  const elapsed = getElapsedMs(timer)

  return {
    elapsed,
    formattedElapsed: toFormatted(elapsed),
  }
}

const toFormatted = (totalMs: number): FormattedElapsed => {
  const totalSeconds = Math.floor(totalMs / 1000)
  const hours = Math.floor(totalSeconds / 3600)
  const minutes = Math.floor((totalSeconds % 3600) / 60)
  const seconds = totalSeconds % 60
  const HH = String(hours).padStart(2, "0")
  const mm = String(minutes).padStart(2, "0")
  const ss = String(seconds).padStart(2, "0")
  return { hours, minutes, seconds, HH, mm, ss }
}

type FormattedElapsed = {
  hours: number
  minutes: number
  seconds: number
  HH: string
  mm: string
  ss: string
}
